import { ImSpinner2 } from "react-icons/im";
import * as SC from "./Spinner.Styled";

/**
 * @param {Object} param0
 * @param {string} [param0.color]
 * @param {import("styled-components").CSSProperties} [param0.wrpStyles]
 */
const Spinner = ({ color = "currentColor", wrpStyles = {} }) => {
  return (
    <SC.SpinnerWrp style={wrpStyles}>
      <ImSpinner2 fill={color} />
    </SC.SpinnerWrp>
  );
};

export default Spinner;
